import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {ReportChart} from '../../../reports/report-chart';

import {SiteAnalyticsReportProvider} from './analytics-report-provider';

type Props = {
    onParamChange: (arg1: any, arg2: boolean) => any;
    onChartClick?: (filters: FilterObject) => void | null | undefined;
    reportDataSummary?: React.ReactNode;
    activeFilters: FilterObject[];
    reportParams: any;
    height?: number;
    containerHeight?: number;
    isFullWidth?: boolean;
    hasBorder?: boolean;
    hasGap?: boolean;
};

export function AnalyticsReportChart(props: Props) {
    const {hasBorder = true, hasGap = false} = props;

    return (
        <SiteAnalyticsReportProvider>
            <ReportChart
                hasBorder={hasBorder}
                height={props.height}
                containerHeight={props.containerHeight}
                hasGap={hasGap}
                activeFilters={props.activeFilters}
                onChartClick={props.onChartClick}
                reportDataSummary={props.reportDataSummary}
                onParamChange={props.onParamChange}
                reportKey='siteAnalytics'
                reportParams={props.reportParams}
                isFullWidth={props.isFullWidth}
            />
        </SiteAnalyticsReportProvider>
    );
}
